import { createContext, useContext, useState, useEffect } from 'react';
import dayjs from 'dayjs';

// Create the context
const DateSettingsContext = createContext();

// Provider component
export const DateSettingsProvider = ({ children }) => {
  const [selectedDate, setSelectedDate] = useState(dayjs()); // Default to today
  const [startDate, setStartDate] = useState(dayjs().subtract(7, 'days')); // Default to 7 days ago
  const [endDate, setEndDate] = useState(dayjs()); // Default to today

  // Load settings from localStorage on mount
  useEffect(() => {
    const savedDate = localStorage.getItem('zignyl-selected-date');
    const savedStartDate = localStorage.getItem('zignyl-start-date');
    const savedEndDate = localStorage.getItem('zignyl-end-date');
    
    if (savedDate) {
      const parsedDate = dayjs(savedDate);
      if (parsedDate.isValid()) {
        setSelectedDate(parsedDate);
      }
    }
    
    if (savedStartDate) {
      const parsedStartDate = dayjs(savedStartDate);
      if (parsedStartDate.isValid()) {
        setStartDate(parsedStartDate);
      }
    }
    
    if (savedEndDate) {
      const parsedEndDate = dayjs(savedEndDate);
      if (parsedEndDate.isValid()) {
        setEndDate(parsedEndDate);
      }
    }
  }, []);

  // Update date and save to localStorage
  const updateDate = (date) => {
    const dayjsDate = dayjs(date);
    setSelectedDate(dayjsDate);
    localStorage.setItem('zignyl-selected-date', dayjsDate.format('YYYY-MM-DD'));
  };

  // Update date range and save to localStorage
  const updateDateRange = (start, end) => {
    const dayjsStart = dayjs(start);
    const dayjsEnd = dayjs(end);
    setStartDate(dayjsStart);
    setEndDate(dayjsEnd);
    localStorage.setItem('zignyl-start-date', dayjsStart.format('YYYY-MM-DD'));
    localStorage.setItem('zignyl-end-date', dayjsEnd.format('YYYY-MM-DD'));
  };

  const value = {
    selectedDate,
    updateDate,
    startDate,
    endDate,
    updateDateRange
  };

  return (
    <DateSettingsContext.Provider value={value}>
      {children}
    </DateSettingsContext.Provider>
  );
};

// Custom hook to use the context
export const useDateSettings = () => {
  const context = useContext(DateSettingsContext);
  if (!context) {
    throw new Error('useDateSettings must be used within a DateSettingsProvider');
  }
  return context;
};
